import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Image from "next/image";
import { Gallery, Item } from 'react-photoswipe-gallery'

import { count } from "../../config/helpers";

const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const PageHead = dynamic(() => import("../Reusables/PageHead"));

const Delivery = ({section_1_list, section_2_list, grid_section, template_page_settings, fleet_images}) => {
    const { template_page_content } = useSelector((state) => state.globalReducer);
    const page_content = template_page_content['delivery'];

    return (
        <>
            <PageHead
                title={`Delivery - ${process.env.brand.brand_name}`}
                description={"Choose delivery and collection options"}
            />
            <BoxContainer className="mb-6">
                {template_page_settings.page_title && (
                    <Typography component="h3" variant="h2" className="text-center f-size_5 mt-4 mb-4">{template_page_settings.page_title}</Typography>
                )}
                <Grid sx={{}} spacing={{ xs: 0, lg: 6}} container>

                    {page_content.section_1_fleet && <Grid sx={{
                        marginBottom: {
                            xs: '1rem',
                            lg: '0'
                        }
                    }} item xs={12} md={6}>
                        <Box sx={{
                            minHeight: {
                                xs: '250px',
                                lg: 'inherit'
                            }
                        }} className="h-100 w-100 position-relative"
                            
                            >
                                <Image
                                    src={`/images/${process.env.brand.acronym}/${page_content.section_1_fleet.content}`}
                                    alt={page_content.section_1_fleet.title}
                                    fill
                                    sizes="(max-width: 768px) 300px,
                                    (max-width: 1200px) 700px,
                                    700px"
                                    priority
                                    style={{
                                        objectFit: 'cover'
                                    }}
                                />
                            </Box>
                    </Grid>}
                    
                    {page_content.list_section_1_container && (
                        <Grid item xs={12} md={6}>

                                <>
                                    <Typography color="grey" className="f-size_3">{page_content.list_section_1_container.content}</Typography>
                                    <Typography className="mt-3 mb-4 f-size_3">{page_content.list_section_1_container.title}</Typography>
                                    <ul className="list-margin">
                                        {section_1_list.map((el, idx) => (
                                            <li key={idx} className="d-flex mb-3">
                                                <CheckCircleOutlineIcon color="primary" fontSize="medium" className="mr-2" />
                                                {el.universal_template_page_content}
                                            </li>
                                        ))}
                                    </ul>
                                </>

                            {/* TODO: Add postcode checker page
                            <Typography>You can use the following link to check if we delivery to your area:</Typography>
                            <Button variant="outlined" color="primary">Postcode Checker</Button> */}

                        </Grid>
                    )}

                    {page_content.list_section_2_container && (
                        <Grid item xs={12} md={6}>

                                <>
                                    <Typography color="grey" className="mb-3 f-size_3">{page_content.list_section_2_container.title}</Typography>
                                    <ul className="list-margin">
                                        {section_2_list.map((el, idx) => (
                                            <li key={idx} className="d-flex mb-3">
                                                <ArrowCircleRightOutlinedIcon color="primary" fontSize="medium" className="mr-2" />
                                                {el.universal_template_page_content}
                                            </li>
                                        ))}
                                    </ul>
                                    <Typography color="grey" className="f-size_3">{page_content.list_section_2_container.content}</Typography>
                                </>

                        </Grid>
                    )}

                    {template_page_settings.delivery_show_fleet == 'yes' && (
                        <Grid item xs={12} md={6}>
                                <Grid spacing={{xs: 2, md: 3}} container>
                                    <Gallery>
                                        {fleet_images && count(fleet_images) > 0 && (
                                            fleet_images.map((fleet_image, idx) => (
                                                <Grid key={idx} item lg={3} xs={6}>
                                                    <Item
                                                        original={fleet_image.zoom}
                                                        thumbnail={fleet_image.image}
                                                        width="750"
                                                        height="750"
                                                    >
                                                        {({ ref, open }) => (
                                                            <Box sx={{
                                                                minHeight: '125px'
                                                            }} className="position-relative"
                                                            ref={ref}
                                                            onClick={open}>
                                                                <Image
                                                                    src={fleet_image.image}
                                                                    alt="Fleet"
                                                                    fill
                                                                    style={{
                                                                        objectFit: 'cover'
                                                                    }}
                                                                    sizes="(max-width: 768px) 200px,
                                                                    (max-width: 1200px) 200px,
                                                                    200px"
                                                                />
                                                            </Box>
                                                        )}
                                                    </Item>
                                                </Grid>
                                            ))
                                        )}
                                    </Gallery>
                                </Grid>
                        </Grid>
                    )}

                    
                    {grid_section && count(grid_section) > 0 && (
                        grid_section.map((section, idx) => (
                        <Grid className="mt-3" key={idx} item xs={12} md={6}>
                            <Typography component="h5" variant="h5" className="uppercase fw-bold mb-2">{section.universal_template_page_content_title}</Typography>
                            <Typography >{section.universal_template_page_content}</Typography>
                        </Grid>
                        ))
                    )}


                </Grid>
            </BoxContainer>
        </>
    )
}

export default Delivery